import Form from "../../componets/Form";

export default function Section5() {
  return (
    <Form />
  );
}
